import { Injectable, NgModule, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@Injectable()

@NgModule({
  imports: [MatDialogModule, BrowserAnimationsModule, FormsModule]
})

export class SupportService {
  myAppUrl: string = "";

  constructor(private _http: Http, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  //** Support
  getSupports() {
    return this._http.get(this.myAppUrl + 'api/support/GetListSupports', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getSupportById(id: number) {
    return this._http.get(this.myAppUrl + 'api/support/GetSupportById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getSupportsForContract(cutomerId: number, deviceId: number) {
    return this._http.get(this.myAppUrl + 'api/support/GetListSupportsForContract/' + cutomerId + "/" + deviceId, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addSupport(data) {
    return this._http.post(this.myAppUrl + 'api/support/AddSupport', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateSupport(data) {
    return this._http.put(this.myAppUrl + 'api/support/UpdateSupport', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteSupport(data) {
    return this._http.delete(this.myAppUrl + "api/support/DeleteSupport/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}  



// WEBPACK FOOTER //
// ./src/app/services/support-service.ts